import { Dialog, DialogActions, DialogContent, DialogContentText, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { AppIconsCloseStyled, CloseIconWrapper, DialogContentStyled, StyledBox, StyledDialogTitle, StyledTypographyTitle, TextConfirmButtonStyled } from "./BasketListDialog.style";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { StyleguideSavioColors,  } from "../../../../configuration/themeSettings";
import { AppIconsCart, AppIconsClose } from "../../../AppIcons";
import { StyledDialogActions } from "./AddBasketButton.style";


interface DialogCreateProps {
    onCreate: (_p: string) => void;
    onClose: (loading: boolean) => void;
    open: boolean;
    name: string;
}
export const CreateBasketDialog = (props:  DialogCreateProps ) => {
    
    const [value, setValue] = React.useState<string>("");

    const { t } = useTranslation();

    useEffect(() => {
        setValue(props.name);
    }, [props.name]);

    const handleClose = () => {
        //setValue("");
        props.onClose(false);
    };

    useEffect(() => {
      setValue("");
    }, [props.open]);

    return (
        <Dialog
            open={props.open !== undefined ? props.open : false}
            fullWidth={true}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            style={{ zIndex: 112000 }}
        >
            <StyledDialogTitle>
                <StyledBox style={{}}>
                    <StyledTypographyTitle variant="subtitle1">
                        {t("common.spareparts.basket.basket_create_title")}
                    </StyledTypographyTitle>
                    <CloseIconWrapper onClick={handleClose}>
                        <AppIconsCloseStyled />
                    </CloseIconWrapper>
                </StyledBox>
            </StyledDialogTitle>

            <DialogContentStyled>
                {/* 
                <DialogContentText>
                    {t("common.spareparts.basket.type_new_basket_name")}
                </DialogContentText>
                */}
                <TextField
                    autoFocus
                    variant="standard"
                    margin="dense"
                    id="name"
                    label={(
                        t("common.spareparts.basket.basket_name") as string
                    ).toUpperCase()}
                    placeholder={(
                        t("common.spareparts.basket.basket_name") as string
                    ).toUpperCase()}
                    type="text"
                    fullWidth
                    slotProps={{
                        input: {
                            color: "primary",
                        },
                        htmlInput: {
                            color: StyleguideSavioColors.grey,
                        },
                    }}
                    value={value}
                    onChange={(event: any) => {
                        if (
                            event.target.value != null &&
                            event.target.value.length <= 100
                        ) {
                            setValue(event.target.value);
                        }
                    }}
                />
            </DialogContentStyled>
            <StyledDialogActions>        
                <TextConfirmButtonStyled
                    variant="contained"
                    onClick={() => {
                        props.onCreate(value);
                        //setValue("");
                    }}
                    color="primary"
                >
                    {t("common.spareparts.OK")}
                </TextConfirmButtonStyled>
            </StyledDialogActions>
        </Dialog>
    );
};
